var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClockDesk(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3990 -14489)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    transform: "translate(3990 14489)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2214.116 14971.506)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1793.671-447.982c-3.048,0-6.1,0-9.143,0a5.031,5.031,0,0,1-5.288-5.293q-.009-6.624,0-13.247a14.522,14.522,0,0,1,12.092-14.3,14.475,14.475,0,0,1,16.648,11.884,14.252,14.252,0,0,1,.2,2.292q.027,6.7.006,13.391a5.007,5.007,0,0,1-4.01,5.174,6.242,6.242,0,0,1-1.358.1C1799.767-447.978,1796.719-447.982,1793.671-447.982Zm12.5-19.113a12.271,12.271,0,0,0-12.634-11.94,12.272,12.272,0,0,0-12.285,13.152,12.26,12.26,0,0,0,13.136,11.779A12.294,12.294,0,0,0,1806.175-467.094Zm-24.888,7.986c-.043.383-.08.56-.081.737,0,1.7-.006,3.406,0,5.108a3.553,3.553,0,0,0,.1.853c.433,1.673,1.635,2.511,3.624,2.513q8.778.008,17.555,0a6.761,6.761,0,0,0,.931-.069,2.863,2.863,0,0,0,2.7-2.646c.154-2.049.089-4.114.114-6.172,0-.034-.056-.068-.166-.194a14.163,14.163,0,0,1-12.305,6.865C1788.458-452.1,1784.315-454.516,1781.287-459.109Z",
    fill: "#707070",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1872.968-432.505q0-1.871,0-3.743c0-.967.286-1.344,1-1.332.668.011.985.45.987,1.38,0,2.231.01,4.462-.007,6.693a1.155,1.155,0,0,0,.508,1.09c1.017.719,2,1.487,2.985,2.254.628.49.743,1.047.364,1.542-.349.456-.914.492-1.535.037-1.277-.935-2.557-1.87-3.788-2.863a1.548,1.548,0,0,1-.492-1.03C1872.934-429.817,1872.968-431.162,1872.968-432.505Z",
    transform: "translate(-80.223 -37.193)",
    fill: "#58beb3",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockDesk);
export default __webpack_public_path__ + "static/media/clock-desk.3b31e510.svg";
export { ForwardRef as ReactComponent };